// "Разрешить уведомления?" overlay — ports notifications.js _showNotificationPrompt.
// Browser-only: shown once after onboarding while permission is still 'default'.
// Android requests its system permission directly from the native push bootstrap.

import { useNotifyPromptStore } from '../store/notifyPromptStore'
import { useInstallGuideStore } from '../store/installGuideStore'
import { usePushNotifications } from '../hooks/usePushNotifications'
import { isNative } from '../lib/platform'
import styles from './NotificationPrompt.module.css'

export default function NotificationPrompt() {
  const open = useNotifyPromptStore((s) => s.open)
  const closeStore = useNotifyPromptStore((s) => s.close)
  const push = usePushNotifications()

  if (!open || isNative) return null

  // Closing this prompt frees the overlay slot — show the install-guide
  // popup right after if one was queued behind it (see installGuideStore).
  const close = () => {
    closeStore()
    useInstallGuideStore.getState().flushPending()
  }

  const allow = async () => {
    await push.enable()
    close()
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        <div className={styles.icon}>🔔</div>
        <h3>Разрешить уведомления?</h3>
        <p>Мы будем присылать вам напоминания и сообщения от психолога</p>
        <div className={styles.actions}>
          <button className={styles.primaryBtn} onClick={allow}>Разрешить</button>
          <button className={styles.textLink} onClick={close}>Позже</button>
        </div>
      </div>
    </div>
  )
}
